export const SET_TOTAL = "SET_TOTAL";
export const SET_TEMPLATE = "SET_TEMPLATE";
export const SET_TEMPLATES_TAB = "SET_TEMPLATES_TAB";
export const SET_USER_TEMPLATES = "SET_USER_TEMPLATES";
export const TAGS_RECEIVED = "TAGS_RECEIVED";
export const TYPES_RECEIVED = "TYPES_RECEIVED";
export const CREATE_TEMPLATE = "CREATE_TEMPLATE";
export const TEMPLATES_RECEIVED = "TEMPLATES_RECEIVED";
export const SET_PROPERTY_TEMPLATE = "SET_PROPERTY_TEMPLATE";
export const SET_FILTERS = "SET_FILTERS";